import { CollisionDetection, pointerWithin, rectIntersection } from '@dnd-kit/core';

const rectIntersectionInPointerRow: CollisionDetection = (args) => {
  const { droppableContainers, droppableRects, pointerCoordinates } = args;
  const [collisionUnderPointer] = pointerWithin(args);
  const rectUnderPointer =
    collisionUnderPointer && droppableRects.get(collisionUnderPointer.id);

  if (!pointerCoordinates || !rectUnderPointer) {
    return rectIntersection(args);
  }

  const droppableContainersInPointerRow = droppableContainers.filter((container) => {
    const rect = droppableRects.get(container.id);

    if (!rect) {
      return false;
    }

    const spansPointerHeight =
      rect.top <= pointerCoordinates.y && pointerCoordinates.y < rect.bottom;
    const isTallerThanRectUnderPointer = rect.height > rectUnderPointer.height;

    return spansPointerHeight && !isTallerThanRectUnderPointer;
  });
  const collisionsInPointerRow = rectIntersection({
    ...args,
    droppableContainers: droppableContainersInPointerRow,
  });

  return collisionsInPointerRow.length > 0
    ? collisionsInPointerRow
    : rectIntersection(args);
};

export default rectIntersectionInPointerRow;
